// Cuentas con acceso total (ven todos los comics sin canjear código).
// Mismo nivel de exposición que el MASTER_CODE hardcodeado que ya existía
// en la app Android — el password se rota manualmente en Supabase.
const MASTER_EMAILS = [
  'drawspirit.ventas@gmail.com',
];

// Alias que escriben los miembros Master en vez del email real (Login.js lo
// traduce antes de llamar a Supabase, así nadie necesita saber el email real).
export const MASTER_LOGIN_ALIAS = 'master';
export const MASTER_LOGIN_EMAIL = MASTER_EMAILS[0];

export function isMasterEmail(email) {
  if (!email) return false;
  return MASTER_EMAILS.includes(email.toLowerCase());
}
